import * as runtime from '@/api/runtime'

import {
  BatchStatisticsGetSelectItemRequest,
  BatchStatisticsGetSelectItemRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemRequest'
import {
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemResult'
import {
  BatchStatisticsReserveRequest,
  BatchStatisticsReserveRequestToJSON
} from '@/api/models/batch/BatchStatisticsReserveRequest'
import {
  BatchStatisticsReserveSelectItemResult,
  BatchStatisticsReserveSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsReserveSelectItemResult'
import {
  BatchStatisticsGetPredefinedSettingRequest,
  BatchStatisticsGetPredefinedSettingRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetPredefinedSettingRequest'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch/BatchStatisticsPageLoadRequest'

export class BatchStatisticsReserveApi extends runtime.BaseAPI {
  /**
   * 検索状態登録
   * @param request
   */
  async registPattern(
    request: BatchStatisticsReserveRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestPost(
      `/batch/statistics/regist_reserve_pattern`,
      BatchStatisticsReserveRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 登録済み出力条件取得
   * @param request
   */
  async getPredefinedSetting(
    request: BatchStatisticsGetPredefinedSettingRequest
  ): Promise<BatchStatisticsReserveSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/list_item`,
      BatchStatisticsGetPredefinedSettingRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsReserveSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * セレクト項目取得
   * @param request
   */
  async getSelectItem(
    request: BatchStatisticsGetSelectItemRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_select_item`,
      BatchStatisticsGetSelectItemRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsReserveSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsReserveSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createReserve(request: BatchStatisticsReserveRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/reserve`,
      BatchStatisticsReserveRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
